module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0135.jpg?v=6678ffb9";